"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraInfoArea = void 0;
const react_1 = __importDefault(require("react"));
require("../styles/eura-info-area.css");
const Header = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement("span", Object.assign({ className: 'info-area-block-header' }, rest), children));
};
const SubHeader = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement("span", Object.assign({ className: 'info-area-block-subheader' }, rest), children));
};
const Text = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement("span", Object.assign({ className: 'info-area-block-text' }, rest), children));
};
const TextBold = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement("span", Object.assign({ className: 'info-area-block-text-bold' }, rest), children));
};
const InfoSection = ({ children, Icon, backgroundColor, }) => {
    const iconSize = '1.2em';
    let bgClassName = '';
    switch (backgroundColor) {
        case 'green':
            bgClassName = 'info-area-block-green';
            break;
        case 'blue':
            bgClassName = 'info-area-block-blue';
            break;
        case 'blue-info':
            bgClassName = 'info-area-block-blue-info';
            break;
        case 'orange':
            bgClassName = 'info-area-block-orange';
            break;
        case 'red':
            bgClassName = 'info-area-block-red';
            break;
        case 'red-warning':
            bgClassName = 'info-area-block-red-warning';
            break;
        case 'grey-box':
            bgClassName = 'info-area-block-grey-box';
            break;
        case 'grey-dark':
            bgClassName = 'info-area-block-grey-dark';
            break;
        case 'grey-light':
            bgClassName = 'info-area-block-grey-light';
            break;
        default:
            break;
    }
    return (react_1.default.createElement("div", { className: `info-area-block ${bgClassName}` },
        Icon && (react_1.default.createElement("div", { className: 'info-area-block-icon' },
            react_1.default.createElement(Icon, { width: iconSize, height: iconSize }))),
        react_1.default.createElement("div", { className: 'info-area-block-content' }, react_1.default.Children.map(children, (item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        react_1.default.createElement("div", { key: index, className: 'info-area-block-content--row' }, item))))));
};
/**
 * Komponentti, joka renderöi sivun oikeaan laitaan tulevan info/toimintopalkin.
 *
 * Käyttöesimerkki:
 * const { Header, SubHeader, Text, InfoSection } = EuraInfoArea
 * const infoArea = <EuraInfoArea>
 *   <InfoSection Icon={UserIdCardIcon}>
 *     <Header>{userData.name}</Header>
 *     <SubHeader>{t('yleiset.suomifi.valtuutus') + ':'}</SubHeader>
 *     <Text>{t('yleiset.rooli.' + userData.consumer)}</Text>
 *   </InfoSection>
 * </EuraInfoArea>
 */
const EuraInfoArea = (props) => {
    const modeClass = props.mode === 'modal' ? 'info-area-modal ' : 'info-area-window';
    const extraClass = props.background === 'white' ? 'info-area-white' : '';
    return (react_1.default.createElement("div", { className: `info-area ${modeClass} ${extraClass}`, "data-testid": props.dataTestId },
        react_1.default.createElement("div", { className: 'info-area-container' }, props.children)));
};
exports.EuraInfoArea = EuraInfoArea;
exports.EuraInfoArea.InfoSection = InfoSection;
exports.EuraInfoArea.Header = Header;
exports.EuraInfoArea.SubHeader = SubHeader;
exports.EuraInfoArea.Text = Text;
exports.EuraInfoArea.TextBold = TextBold;
